class EventPublisher {
    private events: Record<string, ((data: any) => void)[]> = {};

    subscribe = (eventName: string, handler: (data: any) => void) => {
        if (!this.events[eventName]) {
            this.events[eventName] = [];
        }
        this.events[eventName]?.push(handler);
    };

    unsubscribe = (eventName: string, handler: (data: any) => void) => {
        if (this.events[eventName]) {
            const index = this.events[eventName]!.findIndex((item) => item === handler);
            if (index >= 0) {
                this.events[eventName]!.splice(index, 1);
            }
        }
    };

    publish = (eventName: string, data: any) => {
        if (this.events[eventName]) {
            this.events[eventName]!.forEach((handler) => handler(data));
        }
    };
}

const eventPublisher = new EventPublisher();

export default eventPublisher;
